__turbopack_context__.v({
  "SoundCollectionPage__Breadcrumbs": "Yqt8sG_SoundCollectionPage__Breadcrumbs",
  "SoundCollectionPage__Container": "Yqt8sG_SoundCollectionPage__Container",
  "SoundCollectionPage__Content": "Yqt8sG_SoundCollectionPage__Content",
  "SoundCollectionPage__ContentContainer": "Yqt8sG_SoundCollectionPage__ContentContainer",
  "SoundCollectionPage__Desktop": "Yqt8sG_SoundCollectionPage__Desktop",
  "SoundCollectionPage__Mobile": "Yqt8sG_SoundCollectionPage__Mobile",
  "SoundCollectionPage__RichText": "Yqt8sG_SoundCollectionPage__RichText",
});
